'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppPushNotificationsState$Granted$() {
}
export { $c_Lapp_data_AppPushNotificationsState$Granted$ as $c_Lapp_data_AppPushNotificationsState$Granted$ };
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.constructor = $c_Lapp_data_AppPushNotificationsState$Granted$;
/** @constructor */
function $h_Lapp_data_AppPushNotificationsState$Granted$() {
}
export { $h_Lapp_data_AppPushNotificationsState$Granted$ as $h_Lapp_data_AppPushNotificationsState$Granted$ };
$h_Lapp_data_AppPushNotificationsState$Granted$.prototype = $c_Lapp_data_AppPushNotificationsState$Granted$.prototype;
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.hashCode__I = (function() {
  return 1944948379;
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.toString__T = (function() {
  return "Granted";
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.productPrefix__T = (function() {
  return "Granted";
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppPushNotificationsState$Granted$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_AppPushNotificationsState$Granted$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppPushNotificationsState$Granted$, "app.data.AppPushNotificationsState$Granted$", ({
  Lapp_data_AppPushNotificationsState$Granted$: 1,
  Lapp_data_AppPushNotificationsState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_AppPushNotificationsState$Granted$ as $d_Lapp_data_AppPushNotificationsState$Granted$ };
var $n_Lapp_data_AppPushNotificationsState$Granted$;
function $m_Lapp_data_AppPushNotificationsState$Granted$() {
  if ((!$n_Lapp_data_AppPushNotificationsState$Granted$)) {
    $n_Lapp_data_AppPushNotificationsState$Granted$ = new $c_Lapp_data_AppPushNotificationsState$Granted$();
  }
  return $n_Lapp_data_AppPushNotificationsState$Granted$;
}
export { $m_Lapp_data_AppPushNotificationsState$Granted$ as $m_Lapp_data_AppPushNotificationsState$Granted$ };
//# sourceMappingURL=app.data.-App-Push-Notifications-State$-Granted$.js.map
